// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"7c3d9aed","105":"d63d996a","213":"489b8366","239":"36bd41ed","448":"16a5d65f","453":"c2b21152","455":"23c931ca","952":"6da8a733"}[chunkId] + ".chunk.js";
};